import styled from "styled-components"
import media from "styled-media-query"

export const DivWrapper = styled.div`
    background: rgba(255,255,255,0.85);
    border-radius: 10px;
    overflow: hidden;
    width: auto;
    display:flex;
    width: 1000px;
    flex-direction: column;

    ${media.lessThan("large")`
        width: calc(100% - 300px);
    `}

    ${media.lessThan("medium")`
        width: calc(100% - 150px);
    `}

    ${media.lessThan("small")`
        width: calc(100% - 50px);
    `}
`

export default DivWrapper
